export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9270.53212baf.jpg";